import React from 'react';
import './empty_messages.less';

class EmptyMessageComponent extends React.Component {
  constructor(props){
    super(props);
  }

  render(){
    return(
      <div className="empty-messages-wrap">
         <div className="empty-message-elm">
           <div className="empty-message-image-elm"></div>
           <div className="empty-message-header">
             No Messages
           </div>
           <div className="empty-message-text-elm">
             Messages from users will appear here
           </div>
         </div>
      </div>
    )
  }
}

export default EmptyMessageComponent;



// WEBPACK FOOTER //
// app/messages/empty_message_view.jsx